import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1a0f0a] text-[#EFE1C4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold tracking-wider mb-4">PICADAS DEL CAMPO</h3>
            <p className="text-[#b8a080] text-sm leading-relaxed">
              Picadas premium artesanales armadas a medida con productos frescos de campo.
              Elegí tus productos favoritos y nosotros armamos tu picada perfecta.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#D4A574]">Navegación</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-[#b8a080] hover:text-[#D4A574] transition-colors text-sm">Inicio</Link></li>
              <li><Link to="/productos" className="text-[#b8a080] hover:text-[#D4A574] transition-colors text-sm">Productos</Link></li>
              <li><Link to="/presentacion" className="text-[#b8a080] hover:text-[#D4A574] transition-colors text-sm">Nuestras Picadas</Link></li>
              <li>
</li>
              <li><Link to="/contacto" className="text-[#b8a080] hover:text-[#D4A574] transition-colors text-sm">Contacto</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#D4A574]">Contacto</h4>
            <ul className="space-y-2 text-[#b8a080] text-sm">
              <li>info@elpampa.com.ar</li>
              <li>Buenos Aires, Argentina</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#3a2a1a] mt-8 pt-8 text-center text-[#b8a080] text-sm">
           {new Date().getFullYear()} Picadas del Campo  Productos Artesanales
        </div>
      </div>
    </footer>
  );
};

export default Footer;
